import _ from "lodash";
import { SummariseItemsInterface, SummaryItemInterface } from "@/interface/business/item.interface";
import { SummaryItem } from "@/modules/location";
import { CategoryItemsType, SummaryItemType } from "@/types/business/item.type";

/**
 * SummariseItems Class
 * @param {Array<ItemInterface>} Array[Item]
 */
export default class SummariseItems implements SummariseItemsInterface {
  items: Array<SummaryItemInterface>;

  constructor(items: Array<SummaryItemType>, isDigitalMenu: boolean = false) {
    this.items = items.map((item: SummaryItemType): SummaryItemInterface => new SummaryItem(item, isDigitalMenu));
  }

  /**
   * Handle conversion the items to categorise
   * @return {Array<CategoryItemsType>} Array[CategoryItemsType]
   */
  public toCategorise(): Array<CategoryItemsType> {
    let categorise: Array<CategoryItemsType> = [];

    // loop on all array items
    this.items.map((item): any => {
      const category_id = item?.category?.id ? `${item?.category?.id}` : "";
      const category_name = item?.category?.getDisplayName() || "";

      const index = categorise.findIndex((category: any) => category.id === item.category?.id);

      // Update
      if (index >= 0) {
        return (categorise[index].items = [...categorise[index].items, item]);
      }

      // Create
      const categoryItem: CategoryItemsType = {
        name: category_name,
        id: category_id,
        items: [item],
      };

      categorise.push(categoryItem);
    });

    return categorise;
  }

  /**
   * Search on item by name
   * @param {String} query
   * @return {void}
   */
  public findItemByName(query: string): void {
    if (!!query) {
      this.items = _.filter(this.items, (item) => {
        return (
          item.name.toString().toLowerCase().includes(query) || item.local_name.toString().toLowerCase().includes(query)
        );
      });
    }
  }

  destructor() {
    delete this.items;
    delete this.toCategorise;
  }
}
